import MessageContent from "components/MessageContent";
import MessageImage from "components/MessageImage";
import MessageName from "components/MessageName";
import MessageVideo from "components/MessageVideo";
import dateFormat from "dateformat";
import React from "react";

type Props = {
  messages: any;
  message: any;
  index: number;
};

const Message: React.FC<Props> = ({
  messages,
  message,
  index,
}): JSX.Element => {
  const returnNameChat = (messages: any, message: any, index: number) => {
    if (index > 0 && messages[index - 1].user.id !== messages[index].user.id) {
      return (
        <MessageName index={index} name={message.user.name.split(" ")[0]} />
      );
    }

    if (index === 0) {
      return (
        <MessageName index={index} name={message.user.name.split(" ")[0]} />
      );
    }
  };

  return (
    <div className="mt-2">
      {returnNameChat(messages, message, index)}
      <div className="flex flex-row items-center justify-between mt-2 ml-9">
        <div className="flex flex-col">
          {message.attachments.length > 0 &&
            message.attachments.map((attach: any, i: number) => {
              return (
                <div key={i} className="flex flex-row">
                  <div className="flex flex-col">
                    <div className="h-6 w-6 mr-6"></div>
                  </div>
                  <div className="flex flex-col my-2">
                    {attach.type === "image" && (
                      <MessageImage type={attach.type} url={attach.image_url} />
                    )}
                    {attach.type === "video" && (
                      <MessageVideo
                        title={attach.title}
                        url={attach.asset_url}
                      />
                    )}
                  </div>
                </div>
              );
            })}
          {message.html && (
            <div className="flex flex-row">
              <div className="flex flex-col">
                <div className="h-6 w-6 my-auto mr-6"></div>
              </div>
              <div className="flex">
                <MessageContent
                  content={message.html}
                  messageFlagged={message.flaggedMessages}
                />
              </div>
            </div>
          )}
        </div>
        <div className="flex flex-col font-nunito text-xs mr-10">
          {dateFormat(message.created_at, "h:MM:ss TT")}
        </div>
      </div>
    </div>
  );
};

export default Message;
